import React from 'react'
import Menu from './Menu.js'
import Grid from "@material-ui/core/Grid";
import '../assets/css/Order.css'
import Table from '../components/Table/OpenOrderTable.js'
class OpenOrders extends React.Component {
    render() {
        return (
            <div style={{ backgroundColor: 'white' }}>
                <div>
                    <Grid container>
                        <Grid item xs={12}>
                            <Menu />
                        </Grid>
                    </Grid>
                </div>
                <div className="mdata">
                    <Grid container >
                        <Grid item xs={12}>
                            <h2 className="mtextOpenOrder">
                                Open Orders
                            </h2>
                        </Grid>
                    </Grid>

                    <Grid>
                        <Grid item xs={12}>
                            <Table />
                        </Grid>
                    </Grid>
                </div>
            </div>
        )
    }

}

export default OpenOrders;